export default "__VITE_ASSET__CaGjB3nV__"